<template>
  <div class="top_selectBox">
    <el-tabs class="top_tabs" v-model="tabsName" @tab-click="handleClick($event.name)">
      <el-tab-pane :label="$t('components_tabs_time_picker_tabs_time_picker_30')" name="today"></el-tab-pane>
      <el-tab-pane :label="$t('components_tabs_time_picker_tabs_time_picker_31')" name="lastday"></el-tab-pane>
      <el-tab-pane :label="$t('components_tabs_time_picker_tabs_time_picker_32')" name="week"></el-tab-pane>
      <el-tab-pane :label="$t('components_tabs_time_picker_tabs_time_picker_33')" name="month"></el-tab-pane>
      <el-tab-pane :label="$t('components_tabs_time_picker_tabs_time_picker_34')" name="custom"></el-tab-pane>
    </el-tabs>
    <div v-show="tabsName === 'custom'">
      <el-date-picker
        style="width: 60%;"
        type="daterange"
        v-model="customTime"
        :placeholder="$t('components_tabs_time_picker_tabs_time_picker_35')"
        value-format="yyyy-MM-dd"
      ></el-date-picker>
      <el-button class="query_btn" type="primary" @click="checkDaterange">{{$t('components_tabs_time_picker_tabs_time_picker_36')}}</el-button>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import moment from 'moment';
export default {
  props: {
    time: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: 'today'
    }
  },
  data: () => {
    return {
      tabsName: 'today',
      currentTime: [],
      customTime: []
    };
  },
  // watch: {
  //   currentTime() {
  //     this.$emit('update:time', this.currentTime);
  //     this.$emit('change');
  //   }
  // },
  created() {
    this.tabsName = this.name;
    this.handleClick(this.tabsName);
  },
  methods: {
    // 切换tab标签
    handleClick(val) {
      switch (val) {
        case 'today':
          this.currentTime = [moment().format('YYYY-MM-DD'), moment().add(+1, 'days').format('YYYY-MM-DD')];
          break;
        case 'lastday':
          this.currentTime = [moment().add(-1, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
          break;
        case 'week':
          this.currentTime = [
            moment().week(moment().week()).startOf('isoWeek').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case 'month':
          this.currentTime = [
            moment().month(moment().month()).startOf('month').format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
          break;
        case 'custom':
          this.currentTime = ['', ''];
          this.customTime = [];
          break;
      }
      this.$emit('update:time', this.currentTime);
      if(val !== 'custom'){
        this.$emit('change', this.currentTime);
      }
    },
    // 自定义时间查询
    checkDaterange() {
      this.currentTime = this.customTime && this.customTime.length > 0 ? [...this.customTime] : ['', ''];
      this.$emit('update:time', this.currentTime);
      this.$emit('change',  this.currentTime);
    }
  }
};
</script>

<style lang="scss" scoped>
.top_selectBox {
  background-color: #fff;
  border-radius: 4px;
  height: 48px;
  padding: 10px 30px 0;
  display: flex;
  flex-direction: row;
}
.top_tabs {
  height: 1px;
  margin-right: 16px;
}
::v-deep .el-tabs__item {
  width: 80px;
  text-align: center;
  padding: 0 20px 20px 0;
}
::v-deep .el-tabs__nav-wrap::after {
  background-color: #dfe4ed00;
}
.query_btn {
  margin-left: 12px;
}
</style>
